import i18n from "i18next";
import "../../../sass/components/BuyFlowCustomBundle.scss";
import ShowFees from "@/Pages/BuyFlow/ShowFees";
import AddAndRemoveButtons from "@/Pages/BuyFlow/AddAndRemoveButtons";
import UsageFeeDescription from "@/Pages/BuyFlow/UsageFeeDescription";

export default function CustomBundle({state, dispatch}) {

    const overlap = (bundle) => {
        let bundleModulesInCart = state.cart.filter(item => item.type === "package").map(item => item.modules).flat();

        for(let i in bundleModulesInCart) {
            if(bundleModulesInCart[i].productId === bundle.productId) {
                return true;
            }
        }
        return false;
    }

    return (
        <div className="custom-bundle">
            <div className="custom-bundle-title">
                {i18n.t("buy-flow.build-custom-bundle")}
            </div>
            {state.customBundles.filter(bundle => bundle.term === state.toggleValue).map((bundle, key) => {
                return (
                    <div key={key}
                         className={`custom-module-container ${overlap(bundle) ? "disabled-module" : ""}`}
                    >
                        <div className="custom-module">
                            <img className="module-svg" alt={module.sales_name ?? module.name} src={bundle.svg} />
                            <span className="module-title">{bundle.name}</span>
                            <span className="module-price">
                            {state.billingFrequency === "monthly" ?
                                '$' + bundle.price + i18n.t("buy-flow./mo") :
                                <span>
                                    <strike className="slashed-monthly-price">
                                        ${(state.customBundles.filter(b => b.term === "monthly")
                                            .filter(b => b.name === bundle.name)[0].price * 12)
                                            + i18n.t("buy-flow./yr")}
                                    </strike>
                                    &nbsp;&nbsp;${bundle.price * 12}{state.billingFrequency === "monthly" ? i18n.t("buy-flow./mo") : i18n.t("buy-flow./yr")}
                                </span>
                            }
                            </span>
                        </div>
                        {/*<ShowFees state={state} dispatch={dispatch} bundle={bundle} label={i18n.t("buy-flow.fees")}/>*/}
                        <UsageFeeDescription description={bundle.usageFeesDescription}/>
                        <AddAndRemoveButtons
                            bundle={bundle}
                            disabled={overlap(bundle)}
                            state={state}
                            dispatch={dispatch}/>
                    </div>
                )
            })}
        </div>
    )
}
